import { Injectable } from '@angular/core';
import { AppService } from './app.service';


@Injectable()
export class dynamiclabelService {

  constructor(public appService: AppService,) { }
  label = [];
  dynamicLabel = null;
  labelcall(gridName: string, tablename: string, moduleName: string, groupId: any) {

    const data = {
      gridName: gridName,
      tableName: tablename,
      moduleName: moduleName,
      groupId: groupId,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        return this.dynamicLabel
      }, error: (error: any) => {
        throw error;
      }
    });
  }
}

